import { useQuery } from "@tanstack/react-query";
import { getProducts, getSettings } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";
import { TrustBand } from "@/components/TrustBand";

export default function Products() {
  const { data: products = [], isLoading } = useQuery({ queryKey: ["products"], queryFn: getProducts });
  const { data: s } = useQuery({ queryKey: ["settings"], queryFn: getSettings });

  return (
    <div data-testid="products-page">
      <section className="bg-navy">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 text-center">
          <h1 className="font-display font-black text-white text-4xl md:text-5xl tracking-tighter" data-testid="products-title">{s?.products_title}</h1>
          {s?.products_subtitle && (
            <p className="text-white/70 mt-3 max-w-xl mx-auto" data-testid="products-subtitle">{s.products_subtitle}</p>
          )}
        </div>
      </section>

      <section className="bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          {isLoading ? (
            <p className="text-center text-muted-foreground">Se încarcă...</p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-7">
              {products.map((p) => (
                <ProductCard key={p.id} product={p} />
              ))}
            </div>
          )}
        </div>
      </section>

      <TrustBand />
    </div>
  );
}
